import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import WhiteLabelQuery from '@/plugins/graphql/queries/v2/white-label-content.gql';
import PrepaidCreate from '@/plugins/graphql/mutations/v2/prepaid-create.gql';
import BillingFullFragment from '@/plugins/graphql/fragments/v2/billing.gql';
import ButtonGenerator from '@/components/v2/enterprise_plan/ButtonGenerator.vue';
import CurrentSubscribedPlan from '@/plugins/graphql/queries/v2/current-subscribed-plan.gql';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import WhiteLabelRedirectMixin from '@/helpers/mixins/WhiteLabelRedirectMixin';
import { TierType } from '@/helpers/entities/enums/v2/TierType';
import PlanSubscription from '@/plugins/graphql/mutations/v2/enterprise_plan_subscription.gql';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import appBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import AppSubscribedEnterprisePlan from '@/plugins/graphql/queries/v2/app-subscribed-enterprise-plan.gql';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
let EnterprisePlans = class EnterprisePlans extends Mixins(DiyMixin, Mixins(RouterParamsAppMixin, GraphqlErrorMixin, WhiteLabelRedirectMixin, CleverTapEventsMixin, ViewportSizeMixin)) {
    constructor() {
        super(...arguments);
        this.dialogHeader = '';
        this.dialogMessage = '';
        this.currentSubscribedPlan = null;
        this.selectedPlanKey = '';
        this.loading = false;
        this.isAccelerator = false;
        this.isYearly = false;
        this.subscriptionDuration = 1;
        this.whiteLabelContent = null;
    }
    get mutationOnFlight() {
        return this.loading;
    }
    get tierTypes() {
        return Object.values(TierType);
    }
    backgroundColor(data) {
        let color = '';
        if (data === '') {
            color = 'black';
        }
        return `background-color:${color}`;
    }
    get headers() {
        return [
            {
                text: '',
                value: '',
                align: 'center',
                sortable: false,
            },
            // {
            //   text: 'Free Plan',
            //   value: 'free_tier',
            //   align: 'center',
            //   sortable: false,
            // },
            {
                text: 'Starter',
                value: 'pro_starter',
                align: 'center',
                sortable: false,
            },
        ];
    }
    get exclusivesContents() {
        return [
            {
                label: 'Subscribe to Free-Tier',
                starter: 'Go Starter',
                premium: 'Go Premium',
                enterprise: 'Go Enterprise',
            },
            {
                label: 'Yearly Subscription Fee (per user/ per month)',
                free: 'Free',
                starter: `${this.whiteLabelContent
                    ? `${this.toCurrency(this.whiteLabelContent.starterPrice)}`
                    : '₱800'}`,
                premium: `${this.whiteLabelContent
                    ? `${this.toCurrency(this.whiteLabelContent.premiumPrice)}`
                    : '₱8,000'}`,
                enterprise: 'Custom Pricing',
            },
            {
                label: 'Monthly Subscription Fee',
                starter: `${this.whiteLabelContent
                    ? `${this.toCurrency(this.whiteLabelContent.starterPrice)}`
                    : '₱1,000'}`,
                premium: `${this.whiteLabelContent
                    ? `${this.toCurrency(this.whiteLabelContent.premiumPrice)}`
                    : '₱10,000'}`,
                enterprise: 'Custom Pricing',
            },
            {
                label: 'Sales Channel',
                free: '',
                starter: '',
                premium: '',
                enterprise: '',
            },
            {
                label: 'Facebook Messenger',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'GLife',
                free: ' ',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Instagram',
                free: ' ',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Viber',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Monthly Users (Visitors in your Mini-App)',
                free: 'Up to 1,000',
                starter: 'Up to 100,000',
                premium: 'Up to 500,000',
                enterprise: 'Custom',
            },
            {
                label: 'Product Uploads',
                free: '50',
                starter: '1000',
                premium: 'Unlimited',
                enterprise: 'Unlimited',
            },
            {
                label: 'Custom Branded Emailer',
                free: ' ',
                starter: ' ',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Multi-Store Setup Option',
                free: ' ',
                starter: ' ',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Distributor Setup Option',
                free: ' ',
                starter: ' ',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Auto-Order Dispatch Option',
                free: ' ',
                starter: ' ',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Convenience Fee Per Transaction',
                free: '₱10',
                starter: '₱10',
                premium: '₱10',
                enterprise: '₱10',
            },
            {
                label: 'Merchant Technical Support',
                free: '',
                starter: '',
                premium: '',
                enterprise: '',
            },
            {
                label: 'Weekdays Support (Except Holidays)',
                free: 'Within 24 hours.',
                starter: 'Within 8 hours.',
                premium: 'Within 8 hours.',
                enterprise: 'Within 2 hours.',
            },
            {
                label: 'Support Channels',
                free: '',
                starter: '',
                premium: '',
                enterprise: '',
            },
            {
                label: 'Facebook Messenger',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Email',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Access To Payment Options',
                free: '',
                starter: '',
                premium: '',
                enterprise: '',
            },
            {
                label: 'Bank of the Philippine Islands',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'GCash',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'PayMaya',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'PayMongo',
                free: '✓',
                starter: '✓',
                premium: '✓',
                enterprise: '✓',
            },
            {
                label: 'Mini App Customization',
                free: ' ',
                starter: ' ',
                premium: ' ',
                enterprise: '✓',
            },
        ];
    }
    indexFor(key) {
        return this.tierTypes.findIndex((tier) => {
            return tier === key;
        });
    }
    onSubscribe(param) {
        this.selectedPlanKey = param.plan;
        this.dialogHeader = `Confirm ${this.capitalize(param.action)}`;
        this.dialogMessage = `Are you sure you want to ${param.action} to
    ${this.capitalize(param.placeholder)} ?`;
        if (this.isAccelerator) {
            this.dialogMessage = `Are you sure you want to ${param.action} to ${this.capitalize(param.placeholder)}?
                            This will result to the removal of your MSME Accelerator Free Pro Subscription.`;
        }
        this.toggleConfirmationDialog();
    }
    capitalize(msg) {
        return msg[0].toUpperCase() + msg.slice(1);
    }
    onChange(val) {
        this.isYearly = val;
        if (this.isYearly) {
            this.subscriptionDuration = 12;
        }
        if (!this.isYearly) {
            this.subscriptionDuration = 1;
        }
    }
    async generateBilling() {
        let amount = 0.0;
        if (this.selectedPlanKey === 'pro_starter') {
            amount = 9600;
        }
        if (this.selectedPlanKey === 'pro_premium') {
            amount = 96000;
        }
        if (this.subscriptionDuration === 12) {
            await this.$apollo
                .mutate({
                mutation: PrepaidCreate,
                variables: {
                    input: {
                        appUuid: this.appUUID,
                        invoiceAmount: amount,
                    },
                },
                update(cache, { data }) {
                    const { billing } = data.prepaidCreate;
                    cache.writeFragment({
                        fragment: BillingFullFragment,
                        fragmentName: 'Billing',
                        data: billing,
                    });
                },
            })
                .then(() => {
                this.$router.push({
                    name: 'billing',
                    params: { appUuid: this.appUUID },
                });
            })
                .catch((error) => {
                this.errorNotification(error.message);
            });
        }
    }
    async subscribe() {
        this.loading = !this.loading;
        await this.$apollo
            .mutate({
            mutation: PlanSubscription,
            variables: {
                input: {
                    planSlug: this.selectedPlanKey,
                    appUuid: this.appUUID,
                    subscriptionMonths: this.subscriptionDuration,
                },
            },
            refetchQueries: [
                {
                    query: AppSubscribedEnterprisePlan,
                    variables: {
                        appUuid: this.appUUID,
                    },
                },
                {
                    query: appBasic,
                    variables: {
                        appUuid: this.appUUID,
                    },
                },
                {
                    query: CurrentSubscribedPlan,
                    variables: {
                        appUuid: this.appUUID,
                    },
                },
            ],
        })
            .then(() => {
            this.planSubscribe(this.selectedPlanKey, this.subscriptionDuration);
            if (this.isYearly) {
                this.generateBilling();
            }
        })
            .catch((error) => {
            this.errorNotification(error.message);
        })
            .finally(() => {
            this.loading = !this.loading;
            this.hideConfirmationDialog();
        });
    }
    toCurrency(amount) {
        return `₱${amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    }
    mounted() {
        this.viewSubscriptionPlansPage();
    }
};
__decorate([
    Mutation('hideConfirmationDialog')
], EnterprisePlans.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], EnterprisePlans.prototype, "toggleConfirmationDialog", void 0);
EnterprisePlans = __decorate([
    Component({
        apollo: {
            isAccelerator: {
                query: AppSubscribedEnterprisePlan,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.appSubscribedEnterprisePlan && data.appSubscribedEnterprisePlan.accelerator;
                },
            },
            currentSubscribedPlan: {
                query: CurrentSubscribedPlan,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
            },
            whiteLabelContent: {
                query: WhiteLabelQuery,
                variables() {
                    return {
                        origin: this.getOrigin,
                    };
                },
                update(data) {
                    if (data.whiteLabelContent) {
                        return data.whiteLabelContent;
                    }
                    return null;
                },
            },
        },
        components: {
            ButtonGenerator,
            BaseSubtitle,
            ConfirmationDialog,
            PageTitle,
        },
    })
], EnterprisePlans);
export default EnterprisePlans;
